<template>
  <v-container>
    <v-card style="border: black 2px solid">
      <v-card-title>
        <span style="font-weight: bold">
          ตั้งค่าข้อมูล
        </span>
      </v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-expansion-panels popout>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span style="font-weight: bold">
                  ตั้งค่า Template ข้อมูล กลุ่มหน่วยงาน/ภาควิชา สำหรับเงื่อนไขการเข้าร่วมโครงการ
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list>
                  <v-list-item>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6">
                        <v-row class="d-flex justify-center">
                          <v-col
                            cols="12"
                            md="8"
                          >
                            <v-text-field label="ชื่อเรียกกลุ่ม" v-model="GroupName"></v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              md="4"
                          >
                            <v-btn outlined color="primary" @click="AddGroupName" :disabled="disabledBtnGroupName">
                              บันทึกชื่อกลุ่ม
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-list-item class="d-flex justify-center mt-10">
                          <v-data-table
                              :headers="GroupNameDepHeader"
                              :items="groupQuataMs"
                          >
                            <template v-slot:item.action="{item}">
                              <div align="center">
                                <v-btn text @click="DelGroupName(item)" color="red">
                                  ลบ
                                </v-btn>
                              </div>
                            </template>
                          </v-data-table>
                        </v-list-item>
                        <v-divider color="red" class="mt-6"></v-divider>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="8"
                          >
                            <v-autocomplete
                                v-model="GroupSelect"
                              :items="groupQuataMs"
                              item-text="group_name"
                                item-value="id"
                                label="เลือกกลุ่ม"
                                @change="getGroupData"
                            ></v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="d-flex justify-center">
                          <v-col
                              cols="12"
                              md="8"
                          >
                            <v-autocomplete
                                v-model="DepQuotaSelect"
                                label="หน่วยงาน/ภาควิชา"
                                :items="depart"
                                item-text="full_Detail"
                                item-value="dep_id"
                                persistent-hint
                                clearable
                            >
                            </v-autocomplete>
                          </v-col>
                          <v-col
                              cols="12"
                              md="4"
                          >
                            <v-text-field type="number" label="จำนวนผู้เข้าร่วม (ค่าเริ่มต้น)" v-model="GroupCountPerson"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-list-item class="d-flex justify-center">
                          <v-btn outlined color="primary" @click="AddGroupData">
                            เพิ่มข้อมูล
                          </v-btn>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center mt-10">
                          <v-data-table
                              :headers="GroupDataDepHeader"
                              :items="GroupDataDep"
                          >
                            <template v-slot:item.action="{item}">
                              <div align="center">
                                <v-btn text @click="DelGroupData(item)" color="red">
                                  ลบ
                                </v-btn>
                              </div>
                            </template>
                          </v-data-table>
                        </v-list-item>
                        <v-list-item class="d-flex justify-center">
                          <v-btn outlined color="green" @click="SaveDataToDb">
                            บันทึกข้อมูล
                          </v-btn>
                        </v-list-item>
                      </v-col>
                      <v-divider vertical color="red"></v-divider>
                      <v-col
                          cols="12"
                          md="5">
                        <v-list-item>
                          <div v-for="(qroup, idx) in groupQuataMs" :key="idx" style="color: black">
                            <span style="font-weight: bold;cursor: pointer" @click="showGroupDetail(qroup)">{{idx + 1}} - {{qroup.group_name}}</span>
                          </div>
                        </v-list-item>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
<!--            <v-expansion-panel>
              <v-expansion-panel-header>
                <span style="font-weight: bold">
                  แต่งตั้งคณะกรรมการ
                </span>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-list>
                  <v-list-item>
                    <v-row>
                      <v-col
                        cols="12"
                        md="6">
                        <v-list>
                          <v-responsive>
                            <v-text-field label="ชื่อคณะกรรมการ" class="d-block" v-model="commit_Topic"></v-text-field>
                          </v-responsive>
                          <v-list-item>
                            <v-row>
                              <v-col
                                  cols="12"
                                  md="10">
                                <v-autocomplete
                                    v-model="staffSel"
                                    label="ค้นหาบุคลากร"
                                    :items="staffData"
                                    item-text="customDetail"
                                    item-value="perid"
                                    hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                    persistent-hint
                                    clearable
                                    outlined
                                    @keyup="checkKeyEnter"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="2">
                                <v-btn outlined color="green">
                                  เพิ่ม
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item>
                            <v-card>
                              <v-card-subtitle>
                                <span>
                                  รายชื่อคณะกรรมการ
                                </span>
                              </v-card-subtitle>
                              <v-card-text>
                                <div>
                                  <v-spacer></v-spacer>
                                  <v-text-field label="ค้นหา"></v-text-field>
                                </div>
                                <v-data-table
                                  :headers="CommitHeader"
                                  :items="commitGroup"
                                >
                                  <template v-slot:item.action="{item}">
                                    <div class="justify-center">
                                      <v-btn @click="DelCommit(item)" color="red" outlined>
                                        ลบ
                                      </v-btn>
                                    </div>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                            </v-card>
                        </v-list>
                      </v-col>
                      <v-divider vertical color="red"></v-divider>
                      <v-col
                          cols="12"
                          md="5">
                      </v-col>
                    </v-row>
                  </v-list-item>
                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>-->
          </v-expansion-panels>
        </v-row>
      </v-card-text>
    </v-card>
    <template>
      <v-dialog
          v-model="dialog"
          width="500"
      >
        <v-card>
          <v-card-title class="headline grey lighten-2" v-if="groupDetail != null">
            <span style="font-weight: bold">{{groupDetail.group_name}}</span>
          </v-card-title>

          <v-card-text v-if="groupQuataDump.length > 0">
            <div v-for="(qroup, idx) in groupQuataDump" :key="idx" style="color: black" class="pa-2">
              <span>{{idx + 1}} - {{qroup.dep_name}} จำนวนผู้เข้าร่วม : {{qroup.count}} คน</span>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="red"
                text
                @click="dialog = false"
            >
              ปิด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";

export default {
  name: "SettingData",
  data() {
    return {
      commit_Topic: '',
      commit_Sel: '',
      staffSel: '',
      groupQuataDump: [],
      commitGroup: [],
      groupDetail: null,
      dialog: false,
      disabledBtnGroupName: false,
      GroupSelect: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      GroupName: '',
      GroupCountPerson: '',
      DepQuotaSelect: '',
      GroupDataDep: [],
      GroupNameDepHeader: [
        {text: 'ชื่อกลุ่ม', value: 'group_name'},
        {text: '', value: 'action'},
      ],
      GroupDataDepHeader: [
        {text: 'หน่วยงาน', value: 'dep_name'},
        {text: 'จำนวนผู้เข้าร่วม (ค่าเริ่มต้น)', value: 'count'},
        {text: '', value: 'action'},
      ],
      CommitHeader: [
        {text: '#', value: 'idx'},
        {text: 'ชื่อ-สกุล', value: 'full_Name'},
        {text: 'หน่วยงาน', value: 'dep_name'},
        {text: '', value: 'action'},
      ],
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      staffData: 'Staff/getStaff',
      depart: 'Depart/getDepart',
      groupQuataMs: 'Project/getGroupQuota_Ms',
      groupQuata: 'Project/getGroupQuota',
      Permission: 'Permission/getPermissionUser',
      PermissionAdmin: 'Permission/getPermission',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initDepartData: 'Depart/initDepartData',
      initStaffData: 'Staff/initStaffData',
      initGroup_Quota: 'Project/initGroup_Quota',
      initGroup_Quota_Ms: 'Project/initGroup_Quota_Ms',
      getPermissionData: 'Permission/getPermissionData',
      getPermissionUserData: 'Permission/getPermissionUserData',
    }),
    SaveDataToDb() {
      axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/group_quota/group_quota_ms_id/' + this.GroupSelect).then(res => {
          if (res.data) {
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/group_quota/group_quota_ms_id/' + this.GroupSelect, '', {
              headers: {
                'Content-Type': 'application/json',
                'X-REST-METHOD': 'DELETE'
              }
            }).then(resDel => {
              if (resDel.data.status) {
                if (this.GroupDataDep.length > 0) {
                  this.GroupDataDep.map((item, idx) => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/group_quota', {
                      group_quota_ms_id: item.group_quota_ms_id,
                      dep_id: item.dep_id,
                      count: item.count,
                      create_by: this.MeData[0].perid,
                      create_time: 'now()'
                    }, {
                      headers: {
                        'Content-Type': 'application/json',
                        'X-REST-METHOD': 'PUT'
                      }
                    }).then(res => {
                      if (res.data.status) {
                        if (idx == this.GroupDataDep.length - 1){
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ'
                          })
                        }
                      } else {
                        if (idx == this.GroupDataDep.length - 1){
                          this.$swal.fire({
                            icon: 'success',
                            title: 'บันทึกข้อมูลสำเร็จ'
                          })
                        }
                      }
                    })
                  })
                } else {
                  this.$swal.fire({
                    icon: 'success',
                    title: 'บันทึกข้อมูลสำเร็จ'
                  })
                }
              }
            })
          } else {
            this.GroupDataDep.map((item, idx) => {
              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/group_quota', {
                group_quota_ms_id: item.group_quota_ms_id,
                dep_id: item.dep_id,
                count: item.count,
                create_by: this.MeData[0].perid,
                create_time: 'now()'
              }, {
                headers: {
                  'Content-Type': 'application/json',
                  'X-REST-METHOD': 'PUT'
                }
              }).then(res => {
                if (res.data.status) {
                  if (idx == this.GroupDataDep.length - 1){
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                  }
                } else {
                  if (idx == this.GroupDataDep.length - 1){
                    this.$swal.fire({
                      icon: 'success',
                      title: 'บันทึกข้อมูลสำเร็จ'
                    })
                  }
                }
              })
            })
          }
        })
    },
    showGroupDetail(item) {
      this.groupDetail = null
      this.groupDetail = item
      this.groupQuataDump = []
      this.groupQuataDump = this.groupQuata.filter(itemG => itemG.group_quota_ms_id == item.id)
      if (this.groupQuataDump.length > 0) {
        this.groupQuataDump.map(qua_i => {
          this.depart.map(depart => {
            if (qua_i.dep_id == depart.dep_id) {
              qua_i.dep_name = depart.dep_name
            }
          })
        })
      }
      this.dialog = true
    },
    getGroupData() {
      this.GroupDataDep = []
      if (this.groupQuata.length > 0) {
        this.groupQuata.map(item => {
          if(item.group_quota_ms_id == this.GroupSelect) {
            var dep_dump = this.depart.filter(itemDep => itemDep.dep_id == item.dep_id)
            if (dep_dump.length > 0) {
              this.GroupDataDep.push({
                group_quota_ms_id: item.group_quota_ms_id,
                dep_id: dep_dump[0].dep_id,
                depData: dep_dump[0],
                dep_name: dep_dump[0].dep_name,
                count: item.count
              })
            }
          }
        })
      }
    },
    AddGroupData() {
      var group_dump = this.groupQuataMs.filter(item =>item.id == this.GroupSelect)
      if (group_dump.length > 0) {
        if (this.GroupDataDep.filter(item => item.dep_id == this.DepQuotaSelect).length == 0) {
          var dep_dump = this.depart.filter(item => item.dep_id == this.DepQuotaSelect)
          if (dep_dump.length > 0) {
            this.GroupDataDep.push({
              group_quota_ms_id: group_dump[0].id,
              dep_id: dep_dump[0].dep_id,
              depData: dep_dump[0],
              dep_name: dep_dump[0].dep_name,
              count: this.GroupCountPerson,
            })
            this.DepQuotaSelect = ''
            this.GroupCountPerson = ''
          } else {
            this.$swal.fire({
              icon: 'error',
              title: 'ไม่สามารถบันทึกข้อมูลได้ เนื่องจากไม่พบข้อมูลหน่วยงาน/ภาควิชา'
            })
          }
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกข้อมูลได้ พบข้อมูลหน่วยงานที่เลือกอยู่แล้ว'
          })
        }
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดตรวจสอบกลุ่ม หน่วยงาน/ภาควิชา'
        })
      }
    },
    AddGroupName() {
      this.disabledBtnGroupName = true
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/group_quota_ms', {
        group_name: this.GroupName,
        create_by: this.MeData[0].perid,
        create_time: 'now()'
      }, {
        headers: {
          'Content-Type': 'application/json',
          'X-REST-METHOD': 'PUT'
        }
      }).then(res => {
        if (res.data.status) {
          this.GroupName = ''
          this.init()
          this.disabledBtnGroupName = false
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง'
          })
          this.disabledBtnGroupName = false
        }
      })
    },
    DelGroupName(item) {
      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/group_quota_ms/id/' + item.id, {
        active: '0',
        update_by: this.MeData[0].perid
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        if (res.data.status) {
          if (this.GroupSelect == item.id) {
            this.GroupSelect = ''
            this.GroupDataDep = []
          }
          this.$swal.fire({
            icon: 'success',
            title: 'ลบข้อมูลสำเร็จ'
          })
          this.init()
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ไม่สามารถลบข้อมูลได้ โปรดลองอีกครั้ง'
          })
        }
      })
    },
    DelGroupData(item) {
      this.GroupDataDep.map((item_G, idx) => {
        if (item_G.dep_id == item.dep_id) {
          this.GroupDataDep.splice(idx, 1)
        }
      })
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        console.log('here')
      }
    },
    init() {
      this.initDepartData()
      this.initGroup_Quota()
      this.initGroup_Quota_Ms()
      this.initStaffData().then(res => {
        if (res) {
          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
            })
          }
        }
      })
    },
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '9000') {
                this.CheckAdmin = true
                this.init()
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '9000') {
                    this.CheckSubAdmin = true
                    this.init()
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>
.v-label {
  color: black;
}

.v-card {
  border: 1px solid;
}

.v-text-field >>> input {
  color: black;
}

.v-text-field >>> label {
  color: black;
  font-weight: bold;
}

.v-text-field >>> button {
  font-size: 0.1em;
}
</style>